import {
  PERMISSIONS,
  type PermissionCode as SharedPermissionCode,
} from '@shared/constants/permissions'

export { PERMISSIONS }

export type PermissionCode = SharedPermissionCode

const normalizeCode = (code: string): string => code.trim().toUpperCase()

export const buildPermissionSet = (
  permissions: string[] | undefined | null
): Set<string> => {
  if (!Array.isArray(permissions)) {
    return new Set()
  }

  return new Set(
    permissions
      .filter((code): code is string => typeof code === 'string')
      .map(code => normalizeCode(code))
  )
}

export const hasPermission = (
  permissionSet: ReadonlySet<string>,
  permission: PermissionCode
): boolean => {
  if (permissionSet.size === 0) {
    return false
  }

  const normalized = normalizeCode(permission)
  return permissionSet.has(PERMISSIONS.ANY) || permissionSet.has(normalized)
}

export const hasAnyPermission = (
  permissionSet: ReadonlySet<string>,
  permissions: PermissionCode[]
): boolean => {
  if (permissionSet.size === 0) {
    return false
  }

  if (permissionSet.has(PERMISSIONS.ANY)) {
    return true
  }

  return permissions.some(permission =>
    permissionSet.has(normalizeCode(permission))
  )
}
